import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableItem = ({ project, onEdit, onDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: project.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: '15px',
    borderRadius: '10px',
    background: isDragging ? '#1e293b' : '#1e293b',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: isDragging ? '1px solid #3b82f6' : '1px solid transparent',
    zIndex: isDragging ? 10 : 1,
    opacity: isDragging ? 0.8 : 1,
    boxShadow: isDragging ? '0 10px 20px rgba(0,0,0,0.3)' : 'none'
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {/* DRAG HANDLE */}
        <div {...attributes} {...listeners} style={{ cursor: 'grab', color: '#475569', fontSize: '1.2rem', userSelect: 'none' }}>
          ⠿
        </div>
        <span style={{ fontWeight: '500' }}>{project.name}</span>
      </div>
      
      <div style={{ display: 'flex', gap: '12px' }}>
        <button onClick={onEdit} style={{ color: '#3b82f6', background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.9rem' }}>
          Edit
        </button>
        <button onClick={onDelete} style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.9rem' }}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default SortableItem;